import { render, staticRenderFns } from "./LocalTaxModal.vue?vue&type=template&id=a0faa1fe"
import script from "./LocalTaxModal.vue?vue&type=script&lang=js"
export * from "./LocalTaxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports